import api from './api';

// A run translates the whole set synchronously — up to 100 cases at 5 concurrent LLM calls — so it
// needs far more than the default axios timeout.
const RUN_TIMEOUT_MS = 5 * 60 * 1000;

export const translationLabAPI = {
  // bi-pepper's registered translation agents, with their language pairs and default flags
  listAgents: () => api.get('/api/translation-lab/agents'),

  listSets: () => api.get('/api/translation-lab/sets'),
  // raw_text is the pasted or uploaded transcript; the server parses it into cases
  createSet: (body) => api.post('/api/translation-lab/sets', body),
  // appends parsed cases to an existing set, continuing its numbering
  addCases: (id, body) => api.post(`/api/translation-lab/sets/${id}/cases`, body),
  getSet: (id) => api.get(`/api/translation-lab/sets/${id}`),
  deleteSet: (id) => api.delete(`/api/translation-lab/sets/${id}`),

  // body is either { agent_id } or { source_language, target_language }
  runSet: (id, body) => api.post(`/api/translation-lab/sets/${id}/runs`, body, { timeout: RUN_TIMEOUT_MS }),

  saveFeedback: (resultId, body) => api.post(`/api/translation-lab/results/${resultId}/feedback`, body),
};

export default translationLabAPI;
